import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import ExpHPCRender2 from '../../../Image/ExpHPCRender2.png';

const BntGenericBoard = () => {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const InfoBox = ({ title, children }) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          bgcolor: '#A0C8DF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: 1.5,
          flexShrink: 0,
        }}
      >
        <CheckCircleIcon sx={{ color: '#F47921', fontSize: 20 }} />
      </Box>
      <Box>
        <Typography sx={{ fontSize: '15px', fontWeight: 'bold', mb: 1 }}>{title}</Typography>
        <Typography sx={{ ml: 0 }}>{children}</Typography>
      </Box>
    </Box>
  );

  return (
    <div>
      <Button
        size="small"
        onClick={handleClickOpen}
        sx={{
          textTransform: 'none',
          color: '#2b8cb9',
          width: '15%',
          height: '15%',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <InfoIcon />
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        sx={{ '& .MuiDialog-paper': { width: '100%' } }}
      >
        <DialogTitle
          sx={{
            fontWeight: 'bold',
            fontFamily: 'Open Sans',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            fontSize: '24px',
          }}
        >
          Generic HPC Adapter Board
        </DialogTitle>

        <DialogContent
          sx={{
            padding: 3,
            overflowY: 'auto',
            maxHeight: '70vh',
          }}
        >
          {/* Imagem centralizada */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
            <img
              src={ExpHPCRender2}
              alt="Generic HPC Adapter Board"
              style={{ width: '60%', height: '60%' }}
            />
          </Box>

          <Grid container spacing={3}>
            <Grid item xs={6}>
              <InfoBox title="Adapter Board">
                • 8x LV-HPC and 8x HV-HPC <br />
                • Compatible with Generic Expansion Module <br />
                • Mounting on the same mechanical stiffener
              </InfoBox>

              <InfoBox title="Front Panel Connectivity">
                • 2x D-SUB15 HD Socket
              </InfoBox>

              <InfoBox title="Front Panel Interfaces">
                • 8x LV-HPC <br />
                • 8x HV-HPC
              </InfoBox>

              <InfoBox title="Power & Mechanical Budgets">
                • Input Voltage:12V <br />
                • Maximum Consumption:10W <br />
                • Size: 238.75mm x 112mm x 30.48mm <br />
                • Mass: 350 grams <br />
                • Thermal: up to 30W power dissipation (including mounted adapter board)
              </InfoBox>
              <InfoBox title="Processing Power">
                • RISC-V Soft CPU <br />
                • FPGA Programmable Logic 450k System Logic Cells
              </InfoBox>
            </Grid>

            <Grid item xs={6}>
              <InfoBox title="Memory">
                • 2GB DDR4 (16 bit) <br />
                • 256MB NOR Flash for Boot <br />
                • 256MB NOR Flash for application use
              </InfoBox>

              <InfoBox title="Mezzanine Interface 300 pins">
                • 14x Differential HSIOs <br />
                • 32x Differential GPIOs <br />
                • 5x Single ended GPIO <br />
                • +5V/+12V/+30V power rails
              </InfoBox>

              <InfoBox title="Data Rate">
                • Space Wire up to 100 Mbps <br />
                • Space Fiber up to 6.25 Gbit/s <br />
                • 1Mbps CAN
              </InfoBox>

              <InfoBox title="Back Plane Interfaces">
                • 4x Space Wire <br />
                • 2x Space Fibre Dual Lane <br />
                • ADHA Standard P2 <br />
                • ADHA Standard P1 with CAN, I2C, Sync and GPIOs <br />
                • ADHA Backplane module with PSON, RST, HMS and Sync signals
              </InfoBox>

            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BntGenericBoard;
